import React from "react";
import FullScreenSection from "./FullScreenSection";
import { Box, Heading, Image} from "@chakra-ui/react";
import Card from "./Card";

const projects = [
  {
    title: "React Space",
    description:
      "Handy tool belt to create amazing AR components in a React app, with redux integration via middleware️",
    getImageSrc: () => require("../images/photo1.jpg"),
  },
  {
    title: "React Infinite Scroll",
    description:
      "A scrollable bottom sheet with virtualisation support, native animations at 60 FPS and fully implemented in JS land 🔥️",
    getImageSrc: () => require("../images/photo2.jpg"),
  },
  {
    title: "Photo Gallery",
    description:
      "A One-stop shop for photographers to share and monetize their photos, allowing them to have a second source of income",
    getImageSrc: () => require("../images/photo3.jpg"),
  },
  {
    title: "Event planner",
    description:
      "A mobile application for leisure seekers to discover unique events and activities in their city with a few taps",
    getImageSrc: () => require("../images/photo4.jpg"),
  },
];

const ProjectsSection = () => {
  return (
    <FullScreenSection
      backgroundColor="#757575ff"
      isDarkBackground
      p={8}
      alignItems="flex-start"
      spacing={8}
    >
      {/* <Heading as="h1" id="projects-section">
        Featured Projects
      </Heading>
      <Box
        display="grid"
        gridTemplateColumns="repeat(2,minmax(0,1fr))"
        gridGap={8}
      >
        {projects.map((project) => (
          <Card
            key={project.title}
            title={project.title}
            description={project.description}
            imageSrc={project.getImageSrc()}
          />
        ))}
      </Box> */}

      <Heading as="h1" id="projects-section">
        Clients
      </Heading>

      <Box
        display="grid"
        gridTemplateColumns="repeat(1,minmax(0,1fr))"
        gridGap={8}
      >
        <Image src="Tgi_fridays_logo13.svg.png" height={200} className={"desaturated"}/>
        <Image src="Coach_USA.svg.png" height={200} className={"desaturated"}/>
        <Image src="spcLogo-1.png" height={200} className={"desaturated"}/>
      </Box>
    </FullScreenSection>
  );
};

export default ProjectsSection;
